// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Alert = require("../common/Components/Alert.bs.js");
let React = require("react");
let Loader = require("../common/Components/Loader.bs.js");
let ButtonsV5 = require("../common/Components/ButtonsV5.bs.js");
let Form__Label = require("../common/Components/Form__Label.bs.js");
let Next__Image = require("../../reason/next/Next__Image.bs.js");
let ReasonPromise = require("../../reason/ReasonPromise.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let AvatarUploadProvider = require("../../reason/settings/components/AvatarUploadProvider.bs.js");
let FragmentErrorBoundary = require("../common/Components/FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let SelectProfilePhotoButton = require("../common/Components/SelectProfilePhotoButton.bs.js");
let AgentMarketingProfileFeaturedPortraitForm_RemoveMutation_graphql = require("../../__generated__/AgentMarketingProfileFeaturedPortraitForm_RemoveMutation_graphql.bs.js");
let AgentMarketingProfileFeaturedPortraitForm_UpdateMutation_graphql = require("../../__generated__/AgentMarketingProfileFeaturedPortraitForm_UpdateMutation_graphql.bs.js");
let AgentMarketingProfileFeaturedPortraitForm_agentMarketingProfile_graphql = require("../../__generated__/AgentMarketingProfileFeaturedPortraitForm_agentMarketingProfile_graphql.bs.js");

let convertFragment = AgentMarketingProfileFeaturedPortraitForm_agentMarketingProfile_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AgentMarketingProfileFeaturedPortraitForm_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(AgentMarketingProfileFeaturedPortraitForm_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, AgentMarketingProfileFeaturedPortraitForm_agentMarketingProfile_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(AgentMarketingProfileFeaturedPortraitForm_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertVariables = AgentMarketingProfileFeaturedPortraitForm_UpdateMutation_graphql.Internal.convertVariables;

let convertResponse = AgentMarketingProfileFeaturedPortraitForm_UpdateMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = AgentMarketingProfileFeaturedPortraitForm_UpdateMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, AgentMarketingProfileFeaturedPortraitForm_UpdateMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use$1 = RescriptRelay_Mutation.useMutation(convertVariables, AgentMarketingProfileFeaturedPortraitForm_UpdateMutation_graphql.node, convertResponse, convertWrapRawResponse);

let UpdateMutation_imageContentType_decode = AgentMarketingProfileFeaturedPortraitForm_UpdateMutation_graphql.Utils.imageContentType_decode;

let UpdateMutation_imageContentType_fromString = AgentMarketingProfileFeaturedPortraitForm_UpdateMutation_graphql.Utils.imageContentType_fromString;

let UpdateMutation = {
  imageContentType_decode: UpdateMutation_imageContentType_decode,
  imageContentType_fromString: UpdateMutation_imageContentType_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$1
};

let convertVariables$1 = AgentMarketingProfileFeaturedPortraitForm_RemoveMutation_graphql.Internal.convertVariables;

let convertResponse$1 = AgentMarketingProfileFeaturedPortraitForm_RemoveMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse$1 = AgentMarketingProfileFeaturedPortraitForm_RemoveMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation$1 = RescriptRelay_Mutation.commitMutation(convertVariables$1, AgentMarketingProfileFeaturedPortraitForm_RemoveMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let use$2 = RescriptRelay_Mutation.useMutation(convertVariables$1, AgentMarketingProfileFeaturedPortraitForm_RemoveMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let RemoveMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  commitMutation: commitMutation$1,
  use: use$2
};

let acceptedImageTypes = [
  "JPEG",
  "GIF",
  "PNG",
  "WEBP"
];

function AgentMarketingProfileFeaturedPortraitForm$WithoutErrorBoundary(props) {
  let marketingProfile = RescriptRelay_Fragment.useFragment(AgentMarketingProfileFeaturedPortraitForm_agentMarketingProfile_graphql.node, convertFragment, props.marketingProfile);
  let match = use$1();
  let runUpdateMutation = match[0];
  let match$1 = use$2();
  let runRemoveMutation = match$1[0];
  let uploadImage = AvatarUploadProvider.useUploadImage();
  let match$2 = React.useState(() => "InitialState");
  let setState = match$2[1];
  let state = match$2[0];
  let onSelectProfilePhoto = file => {
    setState(param => "Saving");
    ReasonPromise.get(uploadImage(file), result => {
      if (result.TAG !== "Ok") {
        return setState(param => ({
          TAG: "Error",
          _0: "UploadError"
        }));
      }
      let match = result._0;
      let dimensions = match.dimensions;
      let match$1 = match.info;
      let contentType = SelectProfilePhotoButton.ImageMimeType.parse(match$1.contentType);
      if (contentType.TAG === "Ok") {
        let contentType$1 = contentType._0;
        runUpdateMutation({
          input: {
            featuredPhoto: {
              contentType: contentType$1 === "PNG" ? "PNG" : (
                  contentType$1 === "JPEG" ? "JPEG" : (
                      contentType$1 === "WEBP" ? "WEBP" : "GIF"
                    )
                ),
              fileName: match$1.fileName,
              height: dimensions.height,
              key: match$1.key,
              uploadId: match$1.id,
              width: dimensions.width
            }
          }
        }, undefined, undefined, undefined, (response, errors) => {
          let match = response.updateAgentMarketingProfileFeaturedPhoto;
          if (match !== undefined) {
            switch (match.__typename) {
              case "AgentMarketingProfileFeaturedPhotoUpdated" :
                if (errors === undefined) {
                  return setState(param => "InitialState");
                }
                break;
              case "ProfileSettingsChangedError" :
                let settingsChangedMessage = match.settingsChangedMessage;
                return setState(param => ({
                  TAG: "Error",
                  _0: {
                    TAG: "SettingsChanged",
                    _0: settingsChangedMessage
                  }
                }));
              case "__unselected" :
                break;
            }
          }
          setState(param => ({
            TAG: "Error",
            _0: "UploadError"
          }));
        }, _error => setState(param => ({
          TAG: "Error",
          _0: "UploadError"
        })), undefined);
        return;
      }
      let s = contentType._0.VAL;
      setState(param => ({
        TAG: "Error",
        _0: {
          TAG: "UnsupportedMimeType",
          _0: s
        }
      }));
    });
  };
  let onRemovePhoto = () => {
    setState(param => "Saving");
    runRemoveMutation(undefined, undefined, undefined, undefined, (response, errors) => {
      let match = response.removeAgentMarketingProfileFeaturedPhoto;
      if (match !== undefined) {
        switch (match.__typename) {
          case "AgentMarketingProfileFeaturedPhotoRemoved" :
            if (errors === undefined) {
              return setState(param => "InitialState");
            }
            break;
          case "ProfileSettingsChangedError" :
            let settingsChangedMessage = match.settingsChangedMessage;
            return setState(param => ({
              TAG: "Error",
              _0: {
                TAG: "SettingsChanged",
                _0: settingsChangedMessage
              }
            }));
          case "__unselected" :
            break;
        }
      }
      setState(param => ({
        TAG: "Error",
        _0: "RemovePhotoError"
      }));
    }, _error => setState(param => ({
      TAG: "Error",
      _0: "RemovePhotoError"
    })), undefined);
  };
  let tmp;
  let exit = 0;
  if (typeof state !== "object" && state !== "InitialState") {
    tmp = JsxRuntime.jsx(Loader.make, {});
  } else {
    exit = 1;
  }
  if (exit === 1) {
    let tmp$1;
    if (typeof state !== "object") {
      tmp$1 = null;
    } else {
      let message = state._0;
      tmp$1 = typeof message !== "object" ? (
          message === "UploadError" ? JsxRuntime.jsx(Alert.$$Error.make, {
              title: "There was an error updating your photo. Please try again."
            }) : JsxRuntime.jsx(Alert.$$Error.make, {
              title: "There was an error removing your photo. Please try again."
            })
        ) : (
          message.TAG === "SettingsChanged" ? JsxRuntime.jsx(Alert.$$Error.make, {
              title: Stdlib_Option.getOr(message._0, "Your profile settings have changed. Refresh this page before saving.")
            }) : JsxRuntime.jsx(Alert.$$Error.make, {
              title: "The selected photo is not supported. Please try another one."
            })
        );
    }
    let photo = marketingProfile.featuredPhoto;
    tmp = JsxRuntime.jsxs("div", {
      children: [
        tmp$1,
        photo !== undefined ? JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Next__Image.make, {
                src: photo.url,
                width: photo.width,
                height: photo.height,
                unoptimized: true,
                alt: "Your current featured portrait",
                className: "rounded min-w-0"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(SelectProfilePhotoButton.make, {
                    onSelectProfilePhoto: onSelectProfilePhoto,
                    acceptedImageTypes: acceptedImageTypes,
                    children: "Change photo"
                  }),
                  JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                    onClick: param => onRemovePhoto(),
                    size: "small",
                    children: "Remove photo"
                  })
                ],
                className: "flex flex-col gap-4 items-start md:items-center lg:items-start"
              })
            ],
            className: "flex gap-4 md:items-center lg:items-start md:flex-col lg:flex-row justify-between"
          }) : JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(SelectProfilePhotoButton.make, {
              onSelectProfilePhoto: onSelectProfilePhoto,
              acceptedImageTypes: acceptedImageTypes,
              children: "Select photo"
            })
          })
      ],
      className: "flex flex-col gap-4"
    });
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(Form__Label.make, {
              labelText: "Featured Portrait"
            }),
            JsxRuntime.jsx("small", {
              children: "This is an optional, larger photo that will appear in your marketing profile at full size.",
              className: "text-base  text-zinc-500"
            })
          ]
        }),
        className: "pt-2 col-span-2"
      }),
      JsxRuntime.jsx("div", {
        children: tmp,
        className: "mt-2 sm:col-span-3 sm:mt-0 "
      })
    ],
    className: "sm:grid sm:grid-cols-5 sm:items-start gap-16 py-6 space-y-6"
  });
}

let WithoutErrorBoundary = {
  make: AgentMarketingProfileFeaturedPortraitForm$WithoutErrorBoundary
};

function AgentMarketingProfileFeaturedPortraitForm(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "Featured portrait",
    children: JsxRuntime.jsx(AgentMarketingProfileFeaturedPortraitForm$WithoutErrorBoundary, {
      marketingProfile: props.marketingProfile
    })
  });
}

let make = AgentMarketingProfileFeaturedPortraitForm;

exports.Fragment = Fragment;
exports.UpdateMutation = UpdateMutation;
exports.RemoveMutation = RemoveMutation;
exports.acceptedImageTypes = acceptedImageTypes;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* commitMutation Not a pure module */
